/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0809/4069/5840/files/20251021-p1.png',
    'https://cdn.shopify.com/s/files/1/0809/4069/5840/files/20251021-p2.png',
    'https://cdn.shopify.com/s/files/1/0809/4069/5840/files/20251021-p3.png',

    'https://cdn.shopify.com/s/files/1/0809/4069/5840/files/20251021-banner.png',
  ]
  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    slidesPerView: 'auto',
    loop: true,
    speed: 24000,
    spaceBetween: 25,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()
  let prods = window.prod

  function getCur() {
    let color = $('#sp-color .active').data('val')
    let size = $('#sp-size .active').data('val')

    return prods.find(item => item.option1 == color && item.option2 == size)
  }

  function calcChangePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare_at_price = ((getCur().compare_at_price * num) / 100).toFixed(2)
    $('#sp_price1').text(price)
    $('#sp_price2').text(compare_at_price)
    $('.price-font').text(
      ((compare_at_price - price) / compare_at_price).toFixed(2) * 100
    )
  }
  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  $('.product-part2 .sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    calcChangePrice()
  })
  $('.product-part2 .sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    calcChangePrice()
  })
  $(function () {
    let _swiper1 = new Swiper('.sp-swiper-p1', {
      spaceBetween: 10,
      speed: 1,
    })
    $('.product-part2 .sp-option').click(function () {
      const swiperIndex = [
        [3, 4, 5],
        [6, 7, 8],
      ]
      let _index = 1
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      let colorOptions = $('.product-part2 #sp-color .sp-option.active').index()
      _swiper1.slideTo(colorOptions)
      calcChangePrice()
    })

    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    let initNum = 0
    $('.product-part .sp-option').click(function() {
        const colorOption = $("#sp-color .active").index()
    })
    $('.product-part .cart-btn').click(function () {
      let spNum = $('.product-part #calcNumber')[0].value
      initNum += Number(spNum)

      // $("#calcNumber").val(1);
      //   $('#cardNum').html(initNum)

      // handleAddToCart(initNum);
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#calcNumber').val(1)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })
      // var img = $(".product-part .sp-img-p");
      var img = $('.product-part .swiper .swiper-slide-active img')

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })

  //   $(".product-box .sp-opt").click(function () {
  //     $(this).siblings().removeClass("active");
  //     $(this).addClass("active");
  //     let _index = $(this).index();

  //     $(this)
  //       .parents(".product-box")
  //       .find(".sp-p-img")
  //       .eq([_index])
  //       .show()
  //       .siblings(".sp-p-img")
  //       .hide();
  //   });

  //     $(".buy1").click(function () {
  //         let id = $(".sp-opt-group .active").attr("data-id");
  //         window.location.href = "/cart/" + id + ":" + 1;
  //     });
  //     $(".buy2").click(function () {
  //         let id1 = $(".sp-pop2 #sp-color1 .active").attr("data-id");
  //         let id2 = $(".sp-pop2 #sp-color2 .active").attr("data-id");
  //         window.location.href = `/cart/${id1}:1,${id2}:1`
  //     });
  //     $(".buy3").click(function () {
  //         let id1 = $(".sp-pop3 #sp-color1 .active").attr("data-id");
  //         let id2 = $(".sp-pop3 #sp-color2 .active").attr("data-id");
  //         let id3 = $(".sp-pop3 #sp-color3 .active").attr("data-id");
  //         window.location.href = `/cart/${id1}:1,${id2}:1,${id3}:1`
  //     });

  //   $(".sp-pop2 .sp-option").click(function () {
  //     $(this).siblings().removeClass("active");
  //     $(this).addClass("active");
  //     // style选项

  //     let colorOptions = $(".sp-pop2 .sp-color1 .sp-option.active").index();
  //     let colorOptions2 = $(".sp-pop2 .sp-color2 .sp-option.active").index();
  //     $(".sp-pop2 .spimg1")[0].src = spImgList[colorOptions];
  //     $(".sp-pop2 .spimg2")[0].src = spImgList[colorOptions2];
  //   });

  //   $(".sp-pop3 .sp-option").click(function () {
  //     $(this).siblings().removeClass("active");
  //     $(this).addClass("active");
  //     // style选项

  //     let colorOptions = $(".sp-pop3 .sp-color1 .sp-option.active").index();
  //     let colorOptions2 = $(".sp-pop3 .sp-color2 .sp-option.active").index();
  //     let colorOptions3 = $(".sp-pop3 .sp-color3 .sp-option.active").index();
  //     $(".sp-pop3 .spimg1")[0].src = spImgList[colorOptions];
  //     $(".sp-pop3 .spimg2")[0].src = spImgList[colorOptions2];
  //     $(".sp-pop3 .spimg3")[0].src = spImgList[colorOptions3];
  //   });

  //   // 展示多选商品
  //   $(".product-box2 .sp-btn-style2").click(function () {
  //     $(".sp-mask").css("display", "flex");
  //     $(".sp-pop2").show();
  //     $(".sp-pop3").hide();
  //   });
  //   $(".product-box2 .sp-btn-style3").click(function () {
  //     $(".sp-mask").css("display", "flex");
  //     $(".sp-pop3").show();
  //     $(".sp-pop2").hide();
  //   });

  //   // 关闭弹窗按钮

  //   $(".sp-pop .sp-close-btn").click(function (e) {
  //     $(".sp-mask").hide();
  //     $(".sp-pop2").hide();
  //     $(".sp-pop3").hide();
  //   });
  //   $(".sp-pop2 .sp-close-btn").click(function (e) {
  //     $(".sp-mask").hide();
  //     $(".sp-pop2").hide();
  //   });
  //   $(".sp-pop3 .sp-close-btn").click(function (e) {
  //     $(".sp-mask").hide();
  //     $(".sp-pop3").hide();
  //   });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
})
